const translations = {
  common: {
    logo: "KOON-SERVICE",
    viewService: "ဝန်ဆောင်မှုကြည့်ရန်",
    explore: "ကုမ္ပဏီကို စူးစမ်းရန်",
    contactHelp: "အကူအညီအတွက် ဆက်သွယ်ရန်",
    contactButton: "ဆက်သွယ်ရန်",
    footer: "© 2026 Koon-Service. All rights reserved. พัฒนาโดย นักศึกษาสาขาเทคโนโลยีดิจิทัลและสารสนเทศ ระดับปริญญาตรี",
    phone: "ဖုန်း : 062-428-3696",
    line: "Line : @koon_s",
    email: "E-mail : kvs_service@koonservice.com",
    hours: "တိုင်းနေ့ : 8:00 - 17:00",
  },
  nav: {
    home: "ပင်မ",
    services: "ဝန်ဆောင်မှု",
    about: "အကြောင်း",
    contact: "ဆက်သွယ်ရန်",
  },
  language: {
    th: "TH 🇹🇭",
    en: "EN 🇺🇸",
    lo: "LA 🇱🇦",
    mm: "MM 🇲🇲",
  },
  hero: {
    subtitle: "သင့်စီးပွားရေးအတွက် ပရော်ဖက်ရှင်နယ် IT ဖြေရှင်းချက်များ",
    cta: "ကုမ္ပဏီကို စူးစမ်းရန်",
  },
  home: {
    servicesTitle: "ကျွန်တော်တို့၏ဝန်ဆောင်မှုများ",
    whyTitle: "ဘာကြောင့် ကျွန်တော်တို့ကို ရွေးသင့်သလဲ",
    why: [
      { title: "မြန်ဆန်သည်", desc: "ကျွန်တော်တို့သည် စနစ်ပျက်ကွက်မှုကို လျော့ပါးစေပြီး စီးပွားရေးကို ဆက်လက်လည်ပတ်စေပါသည်။" },
      { title: "ပရော်ဖက်ရှင်နယ်", desc: "ကျွန်တော်တို့၏ အဖွဲ့သည် IT အတွေ့အကြုံ ၅ နှစ်ကျော်ရှိပြီး ပြဿနာများကို ထိရောက်စွာ ဖြေရှင်းပေးပါသည်။" },
      { title: "အရည်အသွေးမြင့်", desc: "စနစ်များကို တည်ငြိမ်၊ လုံခြုံစေပြီး ယုံကြည်စိတ်ချရအောင် အပြည်ပြည်ဆိုင်ရာစံချိန်များကို သုံးပါသည်။" },
    ],
    contactTitle: "ဆက်သွယ်ရန် ချန်နယ်များ",
    address1: "Koon Service Co., Ltd.\n329 Moo 10 Main Road, Bang Sao Thong, Bang Sao Thong District, Samut Prakan 10570",
    address2: "Koon Service Co., Ltd.\n18 Soi Lasalle 65, Bang Na Tai, Bang Na, Bangkok 10260",
  },
  services: {
    itService: "အိုင်တီဝန်ဆောင်မှု၊",
    cctv: "လုံခြုံရေး၊",
    equipment: "အိုင်တီပစ္စည်း၊",
    network: "ကွန်ရက်နှင့် လုံခြုံရေး၊",
  },
  itService: {
    title: "IT Service",
    introTitle: "အဖွဲ့အစည်းများအတွက် IT ဝန်ဆောင်မှု",
    introText: "ကျွန်တော်တို့သည် တပ်ဆင်ခြင်း၊ ပြင်ဆင်ခြင်းနှင့် စနစ်ထိန်းသိမ်းခြင်းတို့အတွက် နှစ်ပေါင်းများစွာအတွေ့အကြုံရှိသော IT အင်ဂျင်နီယာများကို ပေးအပ်ပါသည်။",
    detailTitle: "ဝန်ဆောင်မှုကျယ်ပြန့်ချက်",
    pointsLeft: [
      "ကွန်ပျူတာနဲ့ ကွန်ယက်စနစ်တပ်ဆင်ခြင်း",
      "ဟာ့ဒ်ဝဲ/ဆော့ဖ်ဝဲ ပြဿနာစစ်ဆေး ပြင်ဆင်ခြင်း",
      "ဆာဗာနဲ့ အတွင်းစနစ်ထိန်းသိမ်းခြင်း",
      "အသုံးပြုသူထောက်ပံ့မှု (Helpdesk)",
      "WiFi / LAN စနစ်တပ်ဆင်ခြင်း",
    ],
    pointsRight: [
      "IT စနစ်ထိန်းသိမ်းခြင်း",
      "လုံခြုံရေး နဲ့ firewall စီမံခန့်ခွဲခြင်း",
      "ဒေတာမိတ္တူယူခြင်း (Backup)",
      "24/7 စနစ်ကြည့်ရှုခြင်း",
      "IT အကြံပေးခြင်း",
    ],
    problemsTitle: "ဤပြဿနာများကို ကြုံတွေ့နေရင်",
    ctaContact: "ကူညီရန် ဆက်သွယ်ပါ",
  },
  cctv: {
    title: "CCTV & SECURITY",
    introTitle: "CCTV တပ်ဆင်ခြင်းနှင့် ထိန်းသိမ်းခြင်းဝန်ဆောင်မှု",
    introText: "ကျွန်တော်တို့သည် အဖွဲ့အစည်းများ၊ ရုံးများ၊ စက်ရုံများအတွက် CCTV စနစ်အတွက် ဒီဇိုင်း, တပ်ဆင်ခြင်း, ထိန်းသိမ်းခြင်းဝန်ဆောင်မှုများကို ပေးပါသည်။",
    detailTitle: "ဝန်ဆောင်မှုကျယ်ပြန့်ချက်",
    pointsLeft: [
      "သင့်နေရာအလိုက် CCTV စနစ်ဒီဇိုင်းနှင့် တပ်ဆင်ခြင်း",
      "IP ကင်မရာနှင့် Analog ကင်မရာတပ်ဆင်ခြင်း",
      "ကြိုးနှင့် ကွန်ယက်ပစ္စည်းများတပ်ဆင်ခြင်း",
      "NVR / DVR မှတ်တမ်းစနစ်သတ်မှတ်ခြင်း",
      "မိုဘိုင်းနှင့် အင်တာနက်မှ ကြည့်ရှုနိုင်ရန် စနစ်တပ်ဆင်ခြင်း",
    ],
    pointsRight: [
      "CCTV စနစ်ထိန်းသိမ်းခြင်း",
      "ကင်မရာပြဿနာများစစ်ဆေး ပြင်ဆင်ခြင်း",
      "ပြီးသားစနစ်များကို အဆင့်မြှင့်တင်ခြင်း",
      "လုံခြုံရေးစနစ်အတိုင်ပင်ခံ",
      "လစဉ်ထိန်းသိမ်းခြင်းဝန်ဆောင်မှု",
    ],
    problemsTitle: "စီးပွားရေးလုပ္ငန်းများအတွက် CCTV ပြဿနာများ",
    cards: [
      { title: "ပုံမရှင်းခြင်း", desc: "ညအချိန်တွင် ပုံမရှင်းပါ" },
      { title: "တပ်ဆင်မှားခြင်း", desc: "ကင်မရာ မျက်နှာပြင် မဖုံးလွှမ်း" },
      { title: "စနစ်မတည်ငြိမ်", desc: "ကင်မရာ ချိတ်ဆက်မရရှိ" },
      { title: "စနစ်မရှိခြင်း", desc: "ပြဿနာဖြစ်သည့်အခါ မည်သူမျှ မကြည့်ရှု" },
    ],
    ctaContact: "ကူညီရန် ဆက်သွယ်ပါ",
  },
  equipment: {
    title: "IT Equipment",
    introTitle: "အဆင့်အတန်းပြည့် IT ပစ္စည်းများ တင်သွင်းနှင့္ တပ်ဆင်ခြင်း",
    introText: "ကျွန်တော်တို့သည် ကွန်ပျူတာများ၊ ဆာဗာများ၊ ကွန်ယက်ပစ္စည်းများနှင့် ရုံးစနစ်များကို လက်လီရောင်းချပြီး ထိပ်တန်းတပ်ဆင်ပေးပါသည်။",
    detailTitle: "ဝန်ဆောင်မှုကျယ်ပြန့်ချက်",
    pointsLeft: [
      "PC / Notebook ဖြန့်ချိခြင်း",
      "Router, Switch, Access Point ဖြန့်ချိခြင်း",
      "Server နှင့် NAS စနစ် ဖြန့်ချိခြင်း",
      "Printer / Scanner စသည်ဖြင့် ရုံးပစ္စည်းများ",
      "UPS / Rack / ကြိုးများအပါအဝင် ပစ္စည်းများ",
    ],
    pointsRight: [
      "ပစ္စည်းတပ်ဆင် နှင့် ဖွဲ့စည်းခြင်း",
      "အဖွဲ့အစည်းများအတွက် ကွန်ယက်ဒီဇိုင်း",
      "Server နှင့် Backup စနစ်တပ်ဆင်ခြင်း",
      "သင့်လုပ်ငန်းအတွက် သင့်တော်သော ပစ္စည်းရွေးချယ်ရေးအကြံပေး",
      "အရောင်းနောက်ပိုင်းထောက်ပံ့မှု",
    ],
    cards: [
      { title: "ပစ္စည်းဟောင်း", desc: "စနစ်နှေးပြီး အလုပ်အသစ်များ မလိုက်ဖက်" },
      { title: "ရွေးချယ်မှား", desc: "လိုအပ်ချက်နှင့် မကိုက်ညီသော ပစ္စည်း" },
      { title: "စနစ်မတည်ငြိမ်", desc: "ပစ္စည်းများ အကြိမ်ကြိမ် ပြဿနာ" },
      { title: "ထောက်ပံ့ဖို့ မရှိ", desc: "ပြဿနာဖြစ်ချိန်တွင် IT အဖွဲ့ မရှိ" },
    ],
    ctaTitle: "သင့်အဖွဲ့အစည်းအတွက် IT ပစ္စည်းလိုပါသလား?",
    ctaText: "သင့်လုပ်ငန်းအတွက် သင့်တော်သော စနစ်ကို ကျွမ်းကျင်သူနှင့် ပြောပါ",
  },
  network: {
    title: "NETWORK & SECURITY",
    introTitle: "ကွန်ယက်နှင့် လုံခြုံရေး စနစ် တပ်ဆင်ခြင်း",
    introText: "ကျွန်တော်တို့သည် အရွယ်အစားမရွေး အဖွဲ့အစည်းများအတွက် ကွန်ယက်နှင့် လုံခြုံရေး စနစ်များကို ဒီဇိုင်း၊ တပ်ဆင်၊ ထိန်းသိမ်းပေးသည်။",
    detailTitle: "ဝန်ဆောင်မှုကျယ်ပြန့်ချက်",
    pointsLeft: [
      "အဖွဲ့အစည်းအတွင်း LAN / WiFi ကွန်ယက်တပ်ဆင်ခြင်း",
      "Router, Switch, Access Point တပ်ဆင်ခြင်း",
      "Network ဖွဲ့စည်းမှု ဒီဇိုင်း",
      "VLAN တပ်ဆင်ခြင်းနှင့် Traffic စီမံခြင်း",
      "အင်တာနက်နှင့် Cloud ချိတ်ဆက်ခြင်း",
    ],
    pointsRight: [
      "တိုက်ခိုက်မှု ကာကွယ်ရေး Firewall တပ်ဆင်ခြင်း",
      "ဗိုင်းရပ်စ်နှင့် Malware ကာကွယ်ခြင်း",
      "အဝေးမှ အလုပ်လုပ်ရန် VPN တပ်ဆင်ခြင်း",
      "ဒေတာ洩露 ကာကွယ်ခြင်း",
      "ရေပန်းစား Network စောင့်ကြည့်မှု",
    ],
    problemsTitle: "ကွန်ယက်ဆိုင်ရာ ပုံမှန်ပြဿနာများ",
    cards: [
      { title: "အင်တာနက်နှေး", desc: "မတည်ငြိမ်သော ကွန်ယက်ကြောင့် အလုပ်နှေး" },
      { title: "ပိုင်းခြားအချိန်များ", desc: "Network မတည်ငြိမ် ဖြစ်စေသည်" },
      { title: "လုံခြုံရေးတိုက်ခိုက်မှု", desc: "Firewall မရှိပါက အန္တရာယ်ရှိသည်" },
      { title: "ဒေတာမလုံခြုံ", desc: "ဟက်ကာများ သို့မဟုတ် ဒေတာ洩露 ရန်အန္တရာယ်" },
    ],
    ctaTitle: "လုံခြုံသော ကွန်ယက်စနစ်လိုပါသလား?",
    ctaText: "သင့်လုပ်ငန်းအတွက် သင့်တော်သော စနစ်ကို ကျွမ်းကျင်သူနှင့် ပြောပါ",
  },
};
export default translations;